/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useEffect, useRef } from 'react';
export var useFieldFocusOnWindowBlur = function useFieldFocusOnWindowBlur(setFocusState) {
  var hadClickFocusOnInputBlurRef = useRef(undefined);
  var hadClickFocusOnWindowBlurRef = useRef(undefined);
  var handleWindowBlur = function handleWindowBlur() {
    hadClickFocusOnWindowBlurRef.current = hadClickFocusOnInputBlurRef.current;
  };
  var handleWindowFocus = function handleWindowFocus() {
    if (hadClickFocusOnWindowBlurRef.current !== undefined) {
      setFocusState(hadClickFocusOnWindowBlurRef.current);
      hadClickFocusOnWindowBlurRef.current = undefined;
    }
  };
  useEffect(function () {
    window.addEventListener('blur', handleWindowBlur);
    window.addEventListener('focus', handleWindowFocus);
    return function () {
      window.removeEventListener('blur', handleWindowBlur);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, []);
  return hadClickFocusOnInputBlurRef;
};